import { InjectionToken } from '@angular/core';

export const APPLICATION_ACTIONS = new InjectionToken<ApplicationActions>('');

export interface ApplicationActions {
  resetApplication(): Promise<void>;
}
